import React from 'react';

const applications = [
  {
    id: 1,
    title: 'Leather Crafting',
    description: 'Precision cutting and engraving for bags, wallets, and accessories',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20laser%20technology%20cutting%20through%20rich%20brown%20leather%20material%20for%20premium%20handbag%20production%20in%20contemporary%20manufacturing%20workspace%20with%20soft%20natural%20lighting%20and%20cream%20colored%20walls%20highlighting%20craftsmanship%20quality&width=600&height=450&seq=leather-home-opt-001&orientation=landscape',
  },
  {
    id: 2,
    title: 'Metal Engraving',
    description: 'Detailed marking on coated metals and anodized aluminum',
    image: 'https://readdy.ai/api/search-image?query=Precision%20laser%20marking%20machine%20engraving%20fine%20detailed%20patterns%20onto%20silver%20anodized%20aluminum%20metal%20plate%20in%20high-tech%20industrial%20setting%20with%20bright%20white%20lighting%20and%20clean%20modern%20environment&width=450&height=450&seq=metal-home-opt-002&orientation=squarish',
  },
  {
    id: 3,
    title: 'Glass Etching',
    description: 'Beautiful frosted effects on glass and crystal',
    image: 'https://readdy.ai/api/search-image?query=Laser%20engraving%20creating%20sophisticated%20frosted%20artistic%20design%20on%20transparent%20crystal%20glass%20surface%20for%20luxury%20decorative%20items%20in%20elegant%20workshop%20with%20soft%20lighting%20and%20light%20background&width=450&height=450&seq=glass-home-opt-003&orientation=squarish',
  },
  {
    id: 4,
    title: 'Wood Working',
    description: 'Intricate designs on plywood, MDF, and solid wood',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20laser%20cutting%20equipment%20creating%20complex%20decorative%20patterns%20in%20natural%20wood%20plywood%20material%20for%20furniture%20and%20craft%20projects%20in%20bright%20modern%20carpentry%20workshop%20with%20white%20walls&width=450&height=450&seq=wood-home-opt-004&orientation=squarish',
  },
  {
    id: 5,
    title: 'Acrylic Design',
    description: 'Clean cuts and engravings on acrylic sheets and displays',
    image: 'https://readdy.ai/api/search-image?query=High%20precision%20laser%20system%20cutting%20clear%20transparent%20acrylic%20sheet%20material%20for%20professional%20signage%20and%20display%20production%20in%20contemporary%20workshop%20with%20excellent%20lighting%20and%20pale%20neutral%20surroundings&width=450&height=450&seq=acrylic-home-opt-005&orientation=squarish',
  },
  {
    id: 6,
    title: 'Fabric & Textile',
    description: 'Precise cutting for fashion, upholstery, and industrial textiles',
    image: 'https://readdy.ai/api/search-image?query=Modern%20textile%20laser%20cutting%20technology%20precisely%20cutting%20vibrant%20colored%20fabric%20material%20for%20fashion%20design%20applications%20in%20clean%20bright%20manufacturing%20facility%20with%20white%20background%20showing%20accurate%20cutting&width=450&height=450&seq=fabric-home-opt-006&orientation=squarish',
  },
];

const ApplicationsSection = () => {
  const handleImgError = (e) => {
    e.target.src = 'https://via.placeholder.com/400x300?text=Image+Unavailable';
  };

  return (
    <section id="applications" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16">
          <div>
            <span className="text-emerald-500 font-semibold text-sm tracking-wider uppercase">
              Applications
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3">
              Endless Possibilities
            </h2>
          </div>
          <p className="text-gray-600 max-w-md mt-4 lg:mt-0">
            From industrial manufacturing to creative crafts, our laser machines handle diverse
            materials with precision.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {applications.map((app) => (
            <a
              key={app.id}
              href="#"
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-80"
            >
              <img
                src={app.image}
                alt={app.title}
                onError={handleImgError}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2">{app.title}</h3>
                <p className="text-white/90 text-sm">
                  {app.description}
                </p>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-4 group-hover:translate-x-0">
                <i className="ri-arrow-right-up-line text-white text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationsSection;
